import React, { useEffect, useRef, useState } from 'react';
import '../styles/Campaigns.css';
import headerImage from '../assets/denny-book-club-banner.jpg';
import dennyCookClubLogo from '../assets/denny-cook-club-logo.png';
import foodImage from '../assets/denny-food-image.png';
import {useNavigate} from "react-router-dom";
// import insta from './assets/socials-14.svg';
// import youtube from './assets/socials-13.svg';
// import facebook from './assets/socials-15.svg';
// import libstar from './assets/LIBSTAR.png';
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import SEO from "./Components/SEO";


function Campaigns() {
    const formRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const image =
                        entry.target.querySelector('.food-image');

                    if (image) {
                        image.classList.add('slide-in');
                    }
                }
            },
            {
                threshold: 0.2,
            }
        );

        if (formRef.current) {
            observer.observe(formRef.current);
        }

        return () => {
            if (formRef.current) {
                observer.unobserve(formRef.current);
            }
        };
    }, []);
    const nav = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        province: '',
        facebook: '',
        instagram: '',
        tiktok: '',
        marketing: '',
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {

        try {
            setLoading(true);

            const response = await fetch(
                'https://admin.digitalcampaign.co.za/api/denny-cook-club-signups',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: JSON.stringify({
                        full_name: formData.name,
                        email: formData.email,
                        contact_number: formData.phone,
                        province_city: formData.province,
                        facebook_handle: formData.facebook,
                        instagram_handle: formData.instagram,
                        tiktok_handle: formData.tiktok,
                        receive_marketing_updates:
                            formData.marketing === 'true'
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                console.error(data);
                alert('Something went wrong.');
                return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "campaign_signup",
                campaign_name: "denny_cook_club",
            });

            setFormData({
                name: '',
                email: '',
                phone: '',
                province: '',
                facebook: '',
                instagram: '',
                tiktok: '',
                marketing: '',
            });
        } catch (error) {
            console.error(error);
            alert('Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="App">
            <SEO
                title="Denny Cook Club | DENNY"
                description="Join the Denny Cook Club to take part in monthly cooking challenges, share your recipes, connect with fellow food lovers and stand a chance to win exciting prizes."
                keywords="Denny Cook Club, cooking competition, recipe competition, cooking challenges, home cooks, food creators, recipe creators, Denny South Africa, cooking community, win prizes"
            />
            <Header />
            <img
                src={headerImage}
                alt="Denny Book Club Banner"
                width="100%"
            />

            <div className="intro-text">
                <h1 className="intro-text-header">
                    Calling all home cooks, foodies, and content creators!
                </h1>

                <p className="intro-text-body">
                    Your kitchen could make you famous… or at least R2500 richer.
                    <br />
                    Sign up for the Denny Cook Club, get monthly cooking
                    challenges, and if your recipe video gets selected… you
                    could WIN R2500!
                    <br />
                    <br />
                    Because with Denny, now anyone can cook?
                </p>

                <p className="intro-text-footer">
                    Good luck!
                </p>
            </div>

            <div ref={formRef} className="form-container">
                <div className="left-form">
                    <img
                        src={dennyCookClubLogo}
                        alt="Denny Cook Club Logo"
                        className="logo"
                    />

                    <p className="form-text">
                        Where Anyone Can Cook & Be Seen
                    </p>

                    <img
                        src={foodImage}
                        alt="Denny Food"
                        className="food-image"
                    />
                </div>

                <div className="right-form">
                    <div className="form-box">

                        <p className="required-text">
                            * Indicates required question
                        </p>

                        <div className="top-fields">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name & Surname*"
                                className="pill-input"
                                value={formData.name}
                                onChange={handleChange}
                            />

                            <input
                                type="email"
                                name="email"
                                placeholder="Email*"
                                className="pill-input"
                                value={formData.email}
                                onChange={handleChange}
                            />

                            <input
                                type="text"
                                name="phone"
                                placeholder="Contact Number*"
                                className="pill-input"
                                value={formData.phone}
                                onChange={handleChange}
                            />

                            <div className="province-input-wrapper">
                                <select
                                    className="pill-input province-select"
                                    name="province"
                                    value={formData.province}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        Province/City*
                                    </option>

                                    <option>Gauteng</option>
                                    <option>Western Cape</option>
                                    <option>KwaZulu-Natal</option>
                                    <option>Eastern Cape</option>
                                    <option>Free State</option>
                                    <option>Limpopo</option>
                                    <option>Mpumalanga</option>
                                    <option>North West</option>
                                    <option>Northern Cape</option>
                                </select>

                                <span className="plus-icon">+</span>
                            </div>
                        </div>

                        <div className="social-section">
                            <p className="social-heading">
                                Please share your social media handles / usernames*
                            </p>

                            <div className="social-row">
                                <label>Facebook</label>

                                <input
                                    type="text"
                                    name="facebook"
                                    placeholder="Eg, name"
                                    className="social-input"
                                    value={formData.facebook}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="social-row">
                                <label>Instagram</label>

                                <input
                                    type="text"
                                    name="instagram"
                                    placeholder="Eg, @name"
                                    className="social-input"
                                    value={formData.instagram}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="social-row">
                                <label>TikTok</label>

                                <input
                                    type="text"
                                    name="tiktok"
                                    placeholder="Eg, @name"
                                    className="social-input"
                                    value={formData.tiktok}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="marketing-section">
                            <p className="marketing-text">
                                Would you like to receive monthly Denny Cook Club
                                Challenges, amazing marketing communications,
                                promotions and updates?
                            </p>

                            <div className="radio-group">
                                <label className="radio-option">
                                    <input
                                        type="radio"
                                        name="marketing"
                                        value="true"
                                        checked={formData.marketing === 'true'}
                                        onChange={handleChange}
                                    />
                                    <span>Yes</span>
                                </label>

                                <label className="radio-option">
                                    <input
                                        type="radio"
                                        name="marketing"
                                        value="false"
                                        checked={formData.marketing === 'false'}
                                        onChange={handleChange}
                                    />
                                    <span>No</span>
                                </label>
                            </div>
                        </div>

                        <div className="button-row">
                            <button
                                className="signup-button"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Sign Me Up'}
                            </button>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default Campaigns;
